
export default function HorizontalRule({style} : {style?: any}) {


    return(<hr style={style?style:{border: '1px solid #ebe9e6'}}/>)

}